import { hashWithSHA256 } from './createHash'

/**
 * @param {GetPixelResponse} pixelData
 * @param {SubmitBody} submitBody
 */

export const runPixels = async (pixelData, submitBody) => {
  const sub1 = submitBody.sub1
  const email = submitBody.Email
  const phone = submitBody.Phone
  const hashedPhone = hashWithSHA256(phone?.replace(/[- )(]/g, ''))
  const hashedEmail = hashWithSHA256(email)

  const mapObj = {
    VarAffId: submitBody.aff_id,
    VarSub1: sub1 || null,
    VarSub2: submitBody.sub2 || null,
    VarSub3: submitBody.sub3 || null,
    VarSub4: submitBody.sub4 || null,
    VarSub5: submitBody.sub5 || null,
    VarTrid: submitBody.trid || null,
    VarDebtAmount: submitBody.DebtOwed || 0,
    VarCDFBID: submitBody.sub5 || '',
    VarEventID: submitBody.eventID,
    VarHashedEmail: hashedEmail || '',
    VarHashedPhone: hashedPhone || '',
  }

  /**
   * @param {string} str
   * @param {MappedPixelData} mappedObj
   */
  function replaceAll(str, mappedObj) {
    const re = new RegExp(Object.keys(mappedObj).join('|'), 'gi')
    return str.replace(re, function (matched) {
      // @ts-expect-error string is type any
      return mappedObj[matched]
    })
  }

  /**
   * Function to execute script tags in innerHTML
   * @param {HTMLElement} elm
   * @param {string} html
   */
  function setInnerHtml(elm, html) {
    elm.innerHTML = html
    Array.from(elm.querySelectorAll('script')).forEach((oldScript) => {
      const newScript = document.createElement('script')
      Array.from(oldScript.attributes).forEach((attr) =>
        newScript.setAttribute(attr.name, attr.value),
      )
      newScript.appendChild(document.createTextNode(oldScript.innerHTML))
      oldScript.parentNode?.replaceChild(newScript, oldScript)
    })
  }

  if (Array.isArray(pixelData)) {
    pixelData.map((pixel) => {
      const pixelDiv = document.createElement('div')
      pixelDiv.style.display = 'none'
      pixelDiv.id = `pixel${pixel.id}`
      const code = pixel.attributes.code
      const replacedCode = replaceAll(code, mapObj)
      document.body.appendChild(pixelDiv)
      const pixelEl = document.getElementById(`pixel${pixel.id}`)
      if (
        pixel.attributes.sub1 === '' ||
        !pixel.attributes.sub1 ||
        pixel.attributes.sub1 === sub1
      ) {
        if (pixelEl) {
          return setInnerHtml(pixelEl, replacedCode)
        }
      }
      return null
    })
  }
}
